"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
import { forwardRef } from "react";
const VARIANT_STYLES = {
    default: "bg-gruv-electric-lime text-gruv-black",
    secondary: "bg-white/10 text-white/80",
    destructive: "bg-red-500 text-white",
    outline: "border border-white/20 text-white/80",
};
export const Badge = forwardRef(({ variant = "default", className, ...props }, ref) => (_jsx("div", { ref: ref, className: clsx("inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors", VARIANT_STYLES[variant], className), ...props })));
Badge.displayName = "Badge";
